var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.547,
    height: 20,
    viewBox: "0 0 15.547 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evaluation",
    transform: "translate(-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M114.758,4.961h7.656A1.76,1.76,0,0,0,124.172,3.2V1.758A1.76,1.76,0,0,0,122.414,0h-7.656A1.76,1.76,0,0,0,113,1.758V3.2A1.76,1.76,0,0,0,114.758,4.961Z",
    transform: "translate(-53.813)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M71.531,67.3v.574A2.933,2.933,0,0,1,68.6,70.8H60.945a2.933,2.933,0,0,1-2.93-2.93V67.3A2.928,2.928,0,0,0,57,69.513V81.739a2.933,2.933,0,0,0,2.93,2.93h9.687a2.933,2.933,0,0,0,2.93-2.93V69.513A2.928,2.928,0,0,0,71.531,67.3ZM62.125,79.637a.586.586,0,1,1-.954.681l-.3-.426-.3.426a.586.586,0,1,1-.954-.681l.538-.753-.538-.753a.586.586,0,0,1,.954-.681l.3.426.3-.426a.586.586,0,0,1,.954.681l-.538.753Zm.6-5.842-1.562,1.871a.586.586,0,0,1-.974-.113l-.625-1.247a.586.586,0,0,1,1.048-.525l.224.448.989-1.185a.586.586,0,0,1,.9.751Zm6.738,5.724H66.023a.586.586,0,1,1,0-1.172h3.437a.586.586,0,0,1,0,1.172Zm0-4.579H66.023a.586.586,0,1,1,0-1.172h3.437a.586.586,0,0,1,0,1.172Z",
    transform: "translate(0 -64.669)",
    fill: "#7b818e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/Evaluation.7e797bc7bb051b0c18aed1b42316a4fc.svg";
export { ForwardRef as ReactComponent };